<div class="tooltip" *ngIf="globalTooltipInput != null">
  <div class="date">
    {{globalTooltipInput.date | date:'H:mm, d MMM'}}
  </div>

  <table class="value-container">
    <tr *ngFor="let content of globalTooltipInput.contents">
      <ng-container *ngIf="content.value != null">
        <td class="name">{{content.device_name}}:</td>
        <td class="value" style="font-weight: 700">{{content.value | number: '1.1-1'}} </td>
        <td class="unit">{{globalTooltipInput.unit}}</td>
      </ng-container>
      <ng-container *ngIf="content.value == null">
        <td class="name" style="color: #868D94">{{content.device_name}}:</td>
        <td  class="value" style="color: #868D94;">&#8212;</td>
        <td class="unit">{{globalTooltipInput.unit}}</td>
      </ng-container>
    </tr>
  </table>
</div>
